(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/xperten/javascripts/prescript.js') >= 0) return;  svs.modules.push('/components/sport/xperten/javascripts/prescript.js');
'use strict';

svs.sport = svs.sport || {};
svs.sport.xperten = svs.sport.xperten || {};


 })(window);